import { Box, ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BootstrapButton } from './TaskButtonBarButton';
import PropTypes from 'prop-types';

const TaskCommentButtonBar = (props) => {
    const { t } = useTranslation();
    const {style, handleEditComment, handleDeleteComment} = props;
    return (
        <Box
            sx={{
                display:'flex',
                flexDirection: 'column',
                alignItems: 'center',
                '& > *': {
                    m: 1,
                },
            }}
        >
            <ButtonGroup
                style={style}
                size={'small'}
            >
                <BootstrapButton variant={'contained'} size={'small'} onClick={handleEditComment}>{t('common.edit')}</BootstrapButton>
                <BootstrapButton variant={'contained'} size={'small'} onClick={handleDeleteComment}>{t('common.delete')}</BootstrapButton>
            </ButtonGroup>
        </Box>
    )
}

TaskCommentButtonBar.propTypes = {
    style: PropTypes.object,
    handleEditComment: PropTypes.func.isRequired,
    handleDeleteComment: PropTypes.func.isRequired,
};

export default TaskCommentButtonBar;
